import I18n from 'i18n-js';
import React from 'react';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import bind from '@reverbdotcom/commons/src/bind';
import heartFilledIcon from '@reverbdotcom/cadence/icons/core/heart-filled.svg?component';
import heartEmptyIcon from '@reverbdotcom/cadence/icons/core/heart-empty.svg?component';
import { RCIcon } from '@reverbdotcom/cadence/components/RCIcon/RCIcon';

interface Props extends IUserContext {
  openModal: () => void;
  disabled: boolean;
  isFavorited: boolean;
  addText?: string;
  addedText?: string;
  disabledTooltipText?: string;
}

export class FavoriteButton extends React.Component<Props, null> {
  @bind
  handleClick(e) {
    e.preventDefault();

    if (this.props.disabled) {
      return;
    }

    this.props.openModal();
  }

  linkText() {
    if (this.props.isFavorited) {
      return this.props.addedText || I18n.t('discovery.favorites.favoriteButton.hasFavorited.search');
    }

    return this.props.addText || I18n.t('discovery.favorites.favoriteButton.addFavorite.search');
  }

  tooltipText() {
    if (!this.props.disabled) { return null; }

    return this.props.disabledTooltipText ||
      I18n.t('discovery.favorites.favoriteButton.tooltipText');
  }

  render() {
    const { disabled, isFavorited } = this.props;
    return (
      <>
        <button
          className='favorite-button__button'
          onClick={this.handleClick}
          type='button'
          data-disabled={disabled || null}
        >
          <RCIcon svgComponent={isFavorited ? heartFilledIcon : heartEmptyIcon} inline />
          {this.linkText()}
        </button>
      </>
    );
  }
}

export default withUserContext(FavoriteButton);
